// extracted by mini-css-extract-plugin
export default {"wrapper":"A_RadioItem_wrapper__FNTvP","radio":"A_RadioItem_radio__hO3Yh","label":"A_RadioItem_label__RjMJc"};